export const CLIENT_COMMAND_IMPLEMENTED_SCREEN_KEYS = Object.freeze([
  'all-clients',
  'onboard-client',
  'command-center',
  'client-information',
  'database-partition',
  'domains',
  'authentication',
  'active-sessions',
  'roles-permissions',
  'user-profiles',
  'theme',
  'client-files',
  'communications',
  'resources-entitlements',
  'marketplace-payments',
  'billing',
  'activity-logs',
]);
